// ADDED
import React, { useState } from "react";
import ChangeScheduleModule from "../../components/modules/ChangeSchedule/ChangeScheduleModule";
import ChangeScheduleHistory from "../../components/modules/ChangeSchedule/components/ChangeScheduleHistory";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useChangeSchedule } from "../../hooks/useChangeSchedule";
import { LoadingSpinner } from "../../../common/Loading";

function ChangeSchedulePage({ user, userAccess, isHideSideMenu }) {
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const {
    requests, loading, shiftSchedules, formData,
    handleInputChange, handleFileChange, submitRequest,
    showMessage, message, isSuccess
  } = useChangeSchedule(user);

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            
            {/* Header */}
            <div className="mainteHeader p-4 border-b flex justify-between items-center">
              <div>
                <div className='sub-title row text-sm'>
                  <span className="text-gray-400">{"Transaction "} &gt; </span>
                  <span className="border-b border-black">{"Change Schedule"}</span>
                </div>
                <h3 className="text-xl font-bold mt-2">Change Schedule Request</h3>
              </div>

              <button
                onClick={() => setShowHistoryModal(true)}
                className="flex items-center bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-md border-none cursor-pointer transition-colors shadow-sm font-medium"
              >
                <RemoveRedEyeIcon fontSize="small" className="mr-2" />
                VIEW HISTORY
              </button>
            </div>

            <ChangeScheduleModule
              user={user}
              shiftSchedules={shiftSchedules}
              formData={formData}
              handleInputChange={handleInputChange}
              handleFileChange={handleFileChange}
              submitRequest={submitRequest}
              showMessage={showMessage}
              message={message}
              isSuccess={isSuccess}
              loading={loading}
            />
          </div>
        </div>
      </div>

      <ChangeScheduleHistory
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        data={requests || []}
      />

      <LoadingSpinner loading={loading} />
    </>
  );
}

export default ChangeSchedulePage;